(function () {
    'use strict';

    angular
        .module('planInitiativeModule')
        .controller('InitiativeUpdateStatusAssessController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'govProcess'];

    function Controller($scope, $state, topBarService, govProcess) {
        topBarService.setTitleAndIcon('Business Planning', 'fa fa-compass');

        if (!$state.is('initiativeUpdateStatusAssess.noActiveProcess') && !govProcess) {
            $state.go('initiativeUpdateStatusAssess.noActiveProcess', {}, { location: 'replace' });
            return;
        }

        // Go To First Iniative To Assess
        $state.go('initiativeUpdateStatusAssess.initiatives.assess', {}, { location: 'replace' });
    }
})();